import axios from 'axios';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

// The scoreboard (Nic 2026-11-02): names and counts for the reps and the
// specialists, plus the viewer's own list with NEW until they open it.
//   team: 'sales' (GET /onboarding-board/scoreboard) or 'onboarding'
//   (GET /client-onboarding/scoreboard). Both streams invalidate the key.
export const SCOREBOARD_KEY = 'onboarding-scoreboard';
const baseOf = (team) =>
  team === 'onboarding' ? '/client-onboarding' : '/onboarding-board';

export const useScoreboard = (team, enabled = true) =>
  useQuery(
    [SCOREBOARD_KEY, team],
    async () => (await axios.get(`${baseOf(team)}/scoreboard`)).data,
    {
      enabled: !!enabled,
      refetchInterval: 60000,
      refetchOnWindowFocus: true,
      keepPreviousData: true,
    },
  );

// Opening the list: NEW clears on screen at once; the server keeps it cleared.
export const useMarkScoreboardSeen = (team) => {
  const queryClient = useQueryClient();
  return useMutation(
    async () => (await axios.post(`${baseOf(team)}/scoreboard/seen`, {})).data,
    {
      onMutate: async () => {
        await queryClient.cancelQueries([SCOREBOARD_KEY, team]);
        queryClient.setQueryData([SCOREBOARD_KEY, team], (old) =>
          old
            ? {
                ...old,
                mine: {
                  ...old.mine,
                  unseen: 0,
                  items: (old.mine?.items || []).map((i) => ({
                    ...i,
                    new: false,
                  })),
                },
              }
            : old,
        );
      },
      onSettled: () => queryClient.invalidateQueries([SCOREBOARD_KEY, team]),
    },
  );
};
